import React, { Component } from "react";
import {
  InputGroup, InputGroupAddon, Input,
  Row, Col, Button, Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as tonKhoConstant from './constants'
import * as tonKhoAction from './actions'
import { storedb } from '../client/storedb'
import ExcelReader from "../controls/_ExcelReader";
const fileTemplate = '/templates/dsTonKho.xls';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as common from '../../lib/common'
import Select from 'react-select';
class TonKho extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      list: [],
      KhoIds: null,
      selectedOptionKho: null,
      keyword: '',
      TuNgay: null,
      DenNgay: null,
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleKhoChange = selectedOptionKho => {
    var multipleValue = [];
    selectedOptionKho.forEach(function (item) {
      multipleValue.push(parseInt(item.value));
    });
    this.setState({ selectedOptionKho, KhoIds: multipleValue });
  };
  handleHanDungChange(name, date) {
    switch (name) {
      case "TuNgay":
        this.setState({ TuNgay: date.format() })
        break;
      case "DenNgay":
        this.setState({ DenNgay: date.format() })
        break;
      default:
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  buildSelectOptionKho(listKho) {
    var options = [];
    if (listKho && listKho.length > 0) {
      listKho.map((item) => { options.push({ value: item.Id, label: item.Name }) }
      );
    }
    return options;
  }
  fetchList = () => {
    const { tonKhoListRequest } = this.props

    var requestData = {
      StoreId: this.state.StoreId,
      keyword: this.state.keyword,
      KhoIds: this.state.KhoIds || [],
      TuNgay: this.state.TuNgay ? common.parseDatetime(this.state.TuNgay, null).format('YYYYMMDD') : '',
      DenNgay: this.state.DenNgay ? common.parseDatetime(this.state.DenNgay, null).format('YYYYMMDD') : '',
      page: this.state.page,
      per_page: this.state.per_page
    };
    return tonKhoListRequest(requestData);
  }
  fetchListKho = () => {
    const { khoListRequest } = this.props

    var requestData = {
      store_id: this.state.StoreId,
      keyword: '',
      status: 1,
      page: 1,
      per_page: 100
    };
    return khoListRequest(requestData);
  }
  search = () => {
    if (this.props.tonKho.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  DownLoadFile = () => {
    const link = document.createElement('a');
    link.href = fileTemplate;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  exportXls = () => {
    const { tonKhoExportXlsRequest } = this.props
    var requestData = {
      storeId: this.state.StoreId,
      keyword: this.state.keyword,
      tuNgay: this.state.TuNgay || '',
      denNgay: this.state.DenNgay || '',
      khoIds: this.state.KhoIds || [],
    };
    return tonKhoExportXlsRequest(requestData);
  }
  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
      dataErr: []
    }));
  }
  refresh = () => {
    this.setState({
      StoreId: this.state.StoreId,
      keyword: '',
      KhoId: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.tonKho.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  EditTonKhoItem = (item, e) => {
    e.preventDefault();
    this.props.history.push('/tonkho-edit?ton=' + (item.TonKhoId || ""));
  }
  UploadExcel = (data) => {
    let arrData = [];
    if (data.length > 0) {
      var i;
      for (i = 1; i < data.length; i++) {
        let HanDung = '';
        if (data[i][8] != '') {
          let tmpNgay = data[i][8].split('/');
          if (tmpNgay.length == 3) {
            HanDung = tmpNgay[2] + '-' + tmpNgay[1] + '-' + tmpNgay[0];
          }
        }
        arrData.push({
          MaKho: data[i][0],
          TenKho: data[i][1],
          // Key: data[i][2],
          MaThuoc: data[i][2],
          TenThuoc: data[i][3],
          SoLuong: data[i][4],
          GiaNhap: data[i][5],
          GiaBan: data[i][6],
          Dvt: data[i][7],
          HanDung: HanDung,
          ThanhTien: data[i][9],
        })
      }
      const { tonKhoUploadRequest } = this.props
      var requestData = {
        storeId: this.state.StoreId,
        items: arrData
      };
      return tonKhoUploadRequest(requestData);
    }
  }
  componentDidMount() {
    this.fetchListKho();
    this.fetchList();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tonKho.type == tonKhoConstant.TONKHO_LIST_SUCCESS) {
      let { list, item } = nextProps.tonKho;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
    else if (nextProps.tonKho.type == tonKhoConstant.TONKHO_UPLOAD_SUCCESS) {
      let { dataErr } = nextProps.tonKho;
      if (dataErr && dataErr.length > 0) {
        this.setState({ dataErr });
      } else {
        setTimeout(() => {
          this.setState({ modal: false }, () => {
            this.refresh();
          });
        }, 1000)
      }
    }
    else if (nextProps.tonKho.type == tonKhoConstant.TONKHO_EXPORT_SUCCESS) {
      let { item } = nextProps.tonKho;
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_ton_kho.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
  }
  render() {
    const {
      handleSubmit,
      tonKho: {
        listRequesting,
        listKho,
        selectedOptionKho,
        isRequesting,
        isPopupLoading,
        errors,
        messages,
      },
    } = this.props
    const listKhoS = this.buildSelectOptionKho(listKho)
    const { dataErr, list } = this.state
    const canhbaosoluong = common.GetCanhBaoTonKho().CANH_BAO_SO_LUONG
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="2" className="mb-2">
                  <InputGroup size="md">
                    <DatePicker name="TuNgay"
                      placeholderText="Từ ngày"
                      selected={common.parseDatetime(this.state.TuNgay)}
                      onChange={this.handleHanDungChange.bind(this, "TuNgay")}
                      required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="2" className="mb-2">
                  <InputGroup size="md">
                    <DatePicker name="DenNgay"
                      placeholderText="Đến ngày"
                      selected={common.parseDatetime(this.state.DenNgay)}
                      onChange={this.handleHanDungChange.bind(this, "DenNgay")}
                      required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <Select
                      placeholder="--Chọn kho--"
                      styles={common.customSelectStylesMulti}
                      value={selectedOptionKho}
                      onChange={this.handleKhoChange}
                      className="form-control p-0"
                      options={listKhoS}
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </InputGroup>
                </Col>

                <Col sm="12" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Thông tin sản phẩm</InputGroupAddon>
                    <Input name="keyword"
                      placeholder="Tên, mã sản phẩm"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      onKeyDown={e => this.keyPress(e)}
                      autoComplete="off" />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              {/* <Button size="md" color="secondary" className="mr-1" onClick={handleSubmit(this.refresh)}><i className="fa fa-refresh"></i> Làm mới</Button> */}
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
              <Button size="md" color="primary" className="mr-1" onClick={this.toggle}><i className="fa fa-upload"></i> Nhập từ danh sách</Button>
            </div>
            <div className="w-100">
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" width="100" className="text-left">Mã</th>
                    <th scope="col" className="text-left">Tên sản phẩm</th>
                    <th scope="col" width="150" className="text-left">Tên kho</th>
                    <th scope="col" width="100" className="text-right">Số lượng</th>
                    <th scope="col" width="100" className="text-right">Giá nhập</th>
                    <th scope="col" width="100" className="text-right">Giá bán</th>
                    <th scope="col" width="100" className="text-left">ĐVT</th>
                    <th scope="col" width="100" className="text-left">Hạn dùng</th>
                    <th scope="col" width="120" className="text-right">Thành tiền</th>
                    <th scope="col" width="120" className="text-left">Nhóm</th>
                    <th scope="col" width="100" className="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1} className={res.SoLuong < canhbaosoluong ? "text-danger" : ""}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.Sku}</td>
                        <td className="text-left">{res.TenHang}</td>
                        <td className="text-left">{res.TenKho}</td>
                        <td className="text-right">{parseFloat(res.SoLuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.GiaNhap || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.GiaBan || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.TenDvt}</td>
                        <td className="text-left">{res.HanDungExp}</td>
                        <td className="text-right">{parseFloat(res.ThanhTienBan || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.TenNhom}</td>
                        <td scope="row" className="text-center">
                          <div className="text-center">
                            <a className="text-primary pull-left mr-2" title="Kiểm kho" onClick={this.EditTonKhoItem.bind(this, res)}>Kiểm kho</a>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <div>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
              <BlockUi tag="div" blocking={isPopupLoading}>
                <ModalHeader toggle={this.toggle}>Cập nhật tồn kho từ danh sách</ModalHeader>
                <ModalBody>
                  <ExcelReader UploadExcel={this.UploadExcel} />
                  <div style={{ maxHeight: 300, overflowX: "auto" }}>
                    {dataErr && !!dataErr.length && (
                      dataErr.map((res, idx) => (
                        <p key={idx} className="text-danger mb-0"><i className="fa fa-exclamation-circle"></i> {res}</p>
                      ))
                    )}
                  </div>
                  {!isPopupLoading && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {dataErr && dataErr.length == 0 && !isPopupLoading && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button size="md" color="success" onClick={this.DownLoadFile}><i className="fa fa-download"></i> Tải file mẫu</Button>{' '}
                  <Button size="md" color="secondary" onClick={this.toggle}><i className="fa fa-close"></i> Đóng</Button>
                </ModalFooter>
              </BlockUi>
            </Modal>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  tonKho: state.tonKho,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  tonKhoListRequest: tonKhoAction.tonKhoListRequest,
  khoListRequest: tonKhoAction.khoListRequest,
  tonKhoExportXlsRequest: tonKhoAction.tonKhoExportXlsRequest,
  tonKhoUploadRequest: tonKhoAction.tonKhoUploadRequest
})(TonKho)
const formed = reduxForm({
  form: 'tonKho',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/TonKho/TonKho.js